// Clean, light basemap — Apple-Maps-like restraint, pairs with the app's warm light UI.
// Keyless (no domain-locked API key), so the tiles load on the custom domain too and
// in browsers that trim cross-site referrers — the old keyed provider refused those
// requests and left the map canvas empty.
export const MAP_STYLE = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";
export const MAP_STYLE_DARK = "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json";
export const MAP_CENTER = { longitude: -66.07, latitude: 18.44 };